import { motion } from "framer-motion";

const HERO_BG = "https://images.unsplash.com/photo-1530545124313-ce5e8eae55af?w=1920&q=80";

export default function HeroSection() {
  const scrollTo = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <p className="text-sm uppercase tracking-[0.3em] font-medium text-[#0077D1] mb-6">
            Indigenous Aviation Chemistry
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.1] font-bold text-[#0C3A72] mb-6">
            Innovative Solutions{" "}
            <span className="text-[#0077D1]">Engineered</span> for Flight
          </h1>
          <p className="text-lg leading-relaxed text-[#4A627E] max-w-2xl mb-10">
OEM-certified aircraft maintenance solutions, independently tested to Airbus and Boeing standards. Proudly developed and manufactured in India.🇮🇳           </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <motion.a
              href="#services"
              onClick={(e) => scrollTo(e, "#services")}
              data-testid="hero-explore-services-btn"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="inline-flex items-center justify-center bg-[#0077D1] text-white px-8 py-3.5 text-sm uppercase tracking-[0.15em] font-medium hover:bg-[#005BA1] transition-colors duration-300"
            >
              Explore Solutions
            </motion.a>
            <motion.a
              href="#contact"
              onClick={(e) => scrollTo(e, "#contact")}
              data-testid="hero-contact-btn"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="inline-flex items-center justify-center bg-transparent text-[#0C3A72] border border-[#0C3A72] px-8 py-3.5 text-sm uppercase tracking-[0.15em] font-medium hover:bg-[#0C3A72] hover:text-white transition-colors duration-300"
            >
              Contact Us
            </motion.a>
          </div>

          {/* Certification Badges */}
          {/* <div className="mt-16 flex flex-wrap items-center gap-6">
            {["Airbus AIMS 09-00-002", "Boeing BSS 7432", "ISO 9001:2015", "ISO 14001:2015"].map((cert) => (
              <span
                key={cert}
                className="cert-badge text-xs tracking-wider text-[#4A627E] border border-[#0C3A72]/15 px-3 py-1.5 bg-white/50 backdrop-blur-sm"
              >
                {cert}
              </span>
            ))}
          </div> */}
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#0C3A72]/40"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </motion.div>
    </section>
  );
}
